import { matchPath } from 'react-router';
import { hasScopesPermission } from '@tribeplatform/gql-client/lib';
import { RoleType } from '@tribeplatform/gql-client/types';
import { useAuthToken } from '@tribeplatform/react-sdk/hooks';
import { generateMemberPath as dumbGenerateMemberPath, generatePath as dumbGeneratePath, generatePostPath as dumbGeneratePostPath, } from '../../utils/space.utils';
export var SystemSpaceSlug;
(function (SystemSpaceSlug) {
    SystemSpaceSlug["LOGIN"] = "default::login";
    SystemSpaceSlug["DIRECT_LOGIN"] = "default::direct-login";
    SystemSpaceSlug["SIGNUP"] = "default::signup";
    SystemSpaceSlug["JOIN_BY_INVITATION"] = "default::join-with-invite";
    SystemSpaceSlug["ACCEPT_INVITATION"] = "default::accept";
    SystemSpaceSlug["FORGOT_PASSWORD"] = "default::forgot-password";
    SystemSpaceSlug["RESET_PASSWORD"] = "default::reset-password";
    SystemSpaceSlug["VERIFY_EMAIL"] = "default::verify";
    SystemSpaceSlug["MEMBER"] = "default::member";
    SystemSpaceSlug["POST"] = "default::post";
    SystemSpaceSlug["COLLECTION"] = "default::collection";
    SystemSpaceSlug["SEARCH"] = "default::search";
    SystemSpaceSlug["NOTIFICATIONS"] = "default::notifications";
    SystemSpaceSlug["PROFILE_SETTINGS"] = "default::profile-settings";
    SystemSpaceSlug["NOT_FOUND"] = "default::not-found";
    SystemSpaceSlug["HOME"] = "default::home";
    SystemSpaceSlug["MEMBERS"] = "default::members";
    SystemSpaceSlug["SPACES"] = "default::spaces";
})(SystemSpaceSlug || (SystemSpaceSlug = {}));
export const spaceQueriesMapping = {
    [SystemSpaceSlug.LOGIN]: {
        query: 'loginNetwork',
        authorizedRoles: [RoleType.guest],
    },
    [SystemSpaceSlug.SIGNUP]: {
        query: 'joinNetwork',
        authorizedRoles: [RoleType.guest],
    },
    [SystemSpaceSlug.SEARCH]: {
        query: 'search',
    },
    [SystemSpaceSlug.NOTIFICATIONS]: {
        query: 'notifications',
    },
    [SystemSpaceSlug.COLLECTION]: {
        query: 'collections',
    },
    [SystemSpaceSlug.MEMBER]: {
        query: 'authMember',
    },
};
export const useSpaceUtil = () => {
    const { data } = useAuthToken({
        useQueryOptions: {
            // this is here to prevent the whole page from re-rendering
            notifyOnChangeProps: ['data'],
        },
    });
    const { network, member, role } = data || {};
    const { systemSpaces } = network || {};
    const spaceScopes = Object.keys(spaceQueriesMapping).map(key => [
        key,
        spaceQueriesMapping[key],
    ]);
    const permissions = hasScopesPermission(network, spaceScopes.map(p => p[1].query));
    const spacePermissions = permissions
        .map((queryAuthorized, idx) => {
        var _a;
        let authorized = queryAuthorized;
        const spaceMapping = spaceScopes[idx][1];
        if ((spaceMapping === null || spaceMapping === void 0 ? void 0 : spaceMapping.authorizedRoles) &&
            !((_a = spaceMapping === null || spaceMapping === void 0 ? void 0 : spaceMapping.authorizedRoles) === null || _a === void 0 ? void 0 : _a.includes(role === null || role === void 0 ? void 0 : role.type)))
            authorized = false;
        return { [spaceScopes[idx][0]]: authorized };
    })
        .reduce((preValue, value) => ({ ...preValue, ...value }), {});
    const findOne = (slug) => systemSpaces === null || systemSpaces === void 0 ? void 0 : systemSpaces.find(space => space.slug === slug);
    const generatePath = (spaceOrSlug, params, queryParams) => {
        const space = typeof spaceOrSlug === 'string' ? findOne(spaceOrSlug) : spaceOrSlug;
        return dumbGeneratePath(space, params, queryParams).replace(/\/\//g, '/');
    };
    return {
        generatePath,
        generateProfilePath: () => {
            const memberSpace = findOne(SystemSpaceSlug.MEMBER);
            return dumbGenerateMemberPath(memberSpace, member);
        },
        generateMemberPath: (member) => {
            const memberSpace = findOne(SystemSpaceSlug.MEMBER);
            return dumbGenerateMemberPath(memberSpace, member);
        },
        generatePostPath: (space, post, reply) => {
            const postSpace = findOne(SystemSpaceSlug.POST);
            return dumbGeneratePostPath(postSpace, space, post, reply);
        },
        matchPath: (spaceOrSlug, path, params) => {
            var _a, _b;
            if (!spaceOrSlug)
                return null;
            if (path === null || path === undefined)
                return null;
            const space = typeof spaceOrSlug === 'string' ? findOne(spaceOrSlug) : spaceOrSlug;
            const spacePath = generatePath(spaceOrSlug, params).replace(/^\/+|\/+$/g, '');
            const firstPath = path.replace(/^\/+|\/+$/g, '');
            const secondaryPath = `/${firstPath}`;
            return (matchPath(firstPath, {
                path: spacePath,
                exact: (_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.exact,
                strict: false,
            }) ||
                matchPath(secondaryPath, {
                    path: spacePath,
                    exact: (_b = space === null || space === void 0 ? void 0 : space.address) === null || _b === void 0 ? void 0 : _b.exact,
                    strict: false,
                }));
        },
        hasViewPermission: (slug) => !(spacePermissions[slug] === false),
    };
};
//# sourceMappingURL=useSpaceUtil.js.map